import './base-loader.scss';
import template from './base-loader.html';

import _ from 'lodash';

const DETERMINATE_TIMEOUT = 5000;
const DONE_TIMEOUT = 300;

export default angular
  .module('doxy.common.components.baseLoader', [])
  .component('baseLoader', {
    template,
    bindings: {
      isDone: '<',
      isMonochrome: '<',
    },
    controller: function ($timeout) {
      this.$onInit = () => {
        this.isFinalizing = false;
        this.isDeterminate = false;
      };

      const finalize = () => {
        if (this.isFinalizing) return;
        $timeout(() => {
          this.isFinalizing = true;
          this.isDeterminate = true;
          $timeout(() => {
            this.isDeterminate = false;
          }, DONE_TIMEOUT);
        });
      };

      this.$onChanges = (changes) => {
        if (_.get(changes, 'isDone.currentValue') !== true) return;
        finalize();
      };

      $timeout(() => {
        if (this.isFinalizing) return;
        this.isDeterminate = true;
      }, DETERMINATE_TIMEOUT);
    },
  }).name;
